// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"bcf99628b7f4c6f2cdeb","883":"ba7503d1e3abc4d1548e"}[chunkId] + ".js";
};